import { api } from './api';

/** What the account's plan holds (null: no limit) and what is paused over it (D-01). */
export interface PlanLimitsOverview {
  limits: { plan: string; brands: number | null; channelsPerBrand: number | null; seatsPerBrand: number | null };
  paused: { brands: number; channels: number; members: number };
  brands: { id: string; name: string; paused: boolean; createdAt: string }[];
  channels: { id: string; workspaceId: string; platform: string; username: string | null; paused: boolean }[];
  members: { id: string; workspaceId: string; email: string; name: string | null; role: string; paused: boolean; owner: boolean }[];
}

export interface ActiveChoice {
  brandIds?: string[];
  channelIds?: string[];
  memberIds?: string[];
}

/** GET /plan-limits and PUT /plan-limits/active (account owner). */
export const planLimitsService = {
  async get(): Promise<PlanLimitsOverview> {
    const res = await api.get<PlanLimitsOverview>('/plan-limits');
    return res.data;
  },
  async choose(choice: ActiveChoice): Promise<PlanLimitsOverview> {
    const res = await api.put<PlanLimitsOverview>('/plan-limits/active', choice);
    return res.data;
  },
};
